export enum OrderStatus {
    Editable = 'Editable',
    OrderRequested = 'Order Requested',
    OrderConfirmed = 'Order Confirmed',
    OrderShipped = 'Order Shipped',
    OrderNotPlaced = 'Order Not Placed',
    OrderPendingPublish = 'Order Pending Publish',
    Autoshipment = 'Autoshipment',
    OrderSubmitted = 'Order Submitted',
    Pending = 'Pending',
    Review = 'Review',
    Confirmed = 'Confirmed',
    Amended = 'Amended',
    Cancelled = 'Cancelled',
    Published = 'Published',
    Approved = 'Approved',
  } 

export const OrderStatusTranslationMap = { 
  [OrderStatus.Editable]: 'editable',
  [OrderStatus.OrderRequested]: 'orderRequested',
  [OrderStatus.OrderConfirmed]: 'orderConfirmed',
  [OrderStatus.OrderShipped]: 'orderShipped',
  [OrderStatus.OrderNotPlaced]: 'orderNotPlaced',
  [OrderStatus.OrderPendingPublish]: 'orderPendingPublish',
  [OrderStatus.Autoshipment]: 'autoshipment',
  [OrderStatus.OrderSubmitted]: 'orderSubmitted',
  [OrderStatus.Pending]: 'pending',
  [OrderStatus.Review]: 'review',
  [OrderStatus.Confirmed]: 'confirmed',
  [OrderStatus.Amended]: 'amended',
  [OrderStatus.Cancelled]: 'cancelled',
  [OrderStatus.Published]: 'published',
  [OrderStatus.Approved]: 'approved',
} as const; 
 
export function isOrderStatus(value: string | null | undefined): value is OrderStatus {
  return value != null && Object.values(OrderStatus).includes(value as OrderStatus);
}

